import React, { useState } from 'react';
import { generateUID, nullFn } from '../../shared/utils';
import { CardContainer } from '../../shared/components/card';

type SomeArrayType = {
  id: string;
  array: string[];
};

const Child = ({
  id,
  item,
  onUpdatedDrop,
}: {
  item: SomeArrayType;
  id: string;
  onUpdatedDrop: (id: string, value: string) => void;
}): JSX.Element => {
  return (
    <div>
      <button onClick={() => onUpdatedDrop(id, 'some new value')}>
        Log State
      </button>
      {id}
      {item.array.map((i, idx) => {
        <div key={idx}>{i}</div>;
      })}
    </div>
  );
};

const Template: React.FC = (): JSX.Element => {
  const [someArray, setSomeArray] = useState<SomeArrayType[]>([]);

  const addItem = () => {
    const newItem: SomeArrayType = {
      id: generateUID(),
      array: [],
    };

    setSomeArray([...someArray, newItem]);
  };

  return (
    <div>
      <button onClick={addItem}>Add</button>
      <div className='border-b px-4 py-2'>
        {someArray.map((item, idx) => (
          <Child key={idx} id={item.id} item={item} onUpdatedDrop={nullFn} />
        ))}
      </div>
    </div>
  );
};

export class TestingPage extends React.Component {
  render(): JSX.Element {
    return (
      <div className='bg-gray-lightest w-full min-h-screen'>
        <div className='w-3/4 mx-auto py-20'>
          <h1>Tabs Development</h1>
          <CardContainer stripPadding={false}>
            {/* Start Tabs Development Here */}
            <Template />
            {/* End Tabs Development Here */}
          </CardContainer>
        </div>
      </div>
    );
  }
}
